// // src/components/ReportPage.tsx
// import React, { useEffect, useState } from "react";
// import "./ExamReport.css";
 
// const ReportPage = ({payload}) => {

 
//   const [reportData, setReportData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [pdfUrl, setPdfUrl] = useState(null);
 


//   const fetchReport = async () => {
//   try {
//     const res = await fetch('/reports/html_report/', {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json"
//       },
//       credentials: "include",
//       body: JSON.stringify(payload),   // <-- Correct
//     });

//     if (!res.ok) throw new Error("Failed to fetch report");

//     const data = await res.json();
//     const byteCharacters = atob(data.fileBase64);

// const byteNumbers = new Array(byteCharacters.length);

// for (let i = 0; i < byteCharacters.length; i++) {
//     byteNumbers[i] = byteCharacters.charCodeAt(i);
// }

// const byteArray = new Uint8Array(byteNumbers);

// const pdfBlob = new Blob([byteArray], {
//     type: "application/pdf"
// });

// const url = URL.createObjectURL(pdfBlob);
// setPdfUrl(url);

// console.log("HTML REPORT RESPONSE:", data); // <-- Add this

// setReportData(data);

//   } catch (err) {
//     setError(err.message);
//   } finally {
//     setLoading(false);
//   }
// };

 
//   useEffect(() => {
//     fetchReport();
//   }, []);
 
//   // -----------------------------
//   // LOADING STATE
//   // -----------------------------
//   if (loading) {
//     return <div style={{ padding: "40px", fontSize: "20px" }}>Loading report...</div>;
//   }
 
//   // -----------------------------
//   // ERROR STATE
//   // -----------------------------
//   if (error) {
//     return <div style={{ padding: "40px", fontSize: "20px", color: "red" }}>
//       Error: {error}
//     </div>;
//   }
//   console.log("reportData =", reportData);
 
//   const { employee, summary, exams, overallStrengths, overallWeaknesses, finalAssessment } = reportData;
 
//   // Sort exams chronologically for trend chart (oldest → newest)
//   const sortedExams = [...exams].sort((a, b) =>
//     new Date(a.date.split(", ")[0]) - new Date(b.date.split(", ")[0])
//   );
//        if (loading) {
//   return <div>Loading...</div>;
// }

// if (error) {
//   return <div>{error}</div>;
// }

// if (pdfUrl) {
//   return (
//     <iframe
//       src={pdfUrl}
//       title="Combined Report"
//       width="100%"
//       height="800px"
//       style={{ border: "none" }}
//     />
//   );
// }
 
//   return (
//     <>
//       {/* FULLY DYNAMIC – NO HARD-CODED VALUES ANYWHERE */}
     
 
     
 

 
       
       
 
 
//     </>
//   );
// };
 
// export default ReportPage;


// src/components/ReportPage.tsx
import React, { useEffect, useState } from "react";
import axios from "axios";

const ReportPage = ({ payload }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const res = await axios.post("/reports/html_report/", payload, {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const data = res.data;
        console.log(data,"dataaaaaaaaaaaa")

        const byteCharacters = atob(data.fileBase64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], {
          type: "application/pdf",
        });

        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
        console.log(url,"urlllll")
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();

    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
        console.log(pdfUrl,"url")
      }
    };
  }, []);

  if (loading) {
    return <div style={{ padding: 20 }}>Loading report...</div>;
  }

  if (error) {
    return <div style={{ color: "red", padding: 20 }}>{error}</div>;
  }

  return (
    <iframe
      src={pdfUrl}
      title="Employee Report"
      width="100%"
      height="800px"
      style={{ border: "none" }}
    />
  );
};

export default ReportPage;
 
